export const environment = {
  production: false,
  apiUrl: 'https://pre-brokertool.europair.com/services/',
  oAuthConfig: {
    issuer:
      'https://login.microsoftonline.com/55f61621-dc4f-492f-86ec-62ffaace576e/v2.0',
    redirectUri: window.location.origin + '/login',
    postLogoutRedirectUri: window.location.origin + '/login',
    clientId: '37bec995-6148-440d-855f-64396759b4aa',
    responseType: 'code',
    strictDiscoveryDocumentValidation: false,
    scope: 'openid api://37bec995-6148-440d-855f-64396759b4aa/app profile',
  },
  crmURL: 'https://europair-des.crm4.dynamics.com/',
  title: 'Pre Brokertool',
  favIcon: 'PREBT.png',
  usersManulUrl: 'https://www.europair.com/en/manuals',
  sidebarColor: '#ff9933'
};
